// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddNewButton-module_add_button_wJgiL {
}

.AddNewButton-module_disabled_fpheU {
}`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Buttons/AddNewButton.module.css"],"names":[],"mappings":"AAAA;AAEA;;AAEA;AAEA","sourcesContent":[".add_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n}\n\n.disabled {\n  composes: disabled from 'Styles/styles.module.css';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add_button": `AddNewButton-module_add_button_wJgiL ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"disabled": `AddNewButton-module_disabled_fpheU ${___CSS_LOADER_ICSS_IMPORT_0___.locals["disabled"]}`
};
export default ___CSS_LOADER_EXPORT___;
